<template>
	<!-- DOC
	 la pagina si occupa di suddividere render esempio e componenti esponendo un solo componente
	 si basa su "macro sezioni di compoennti defuniti sotto"

	 il componente generico aggiunge un'ulteriore livello di astrazione

	 -->
	<div :key="element.id + isEditable">
		<div v-if="input.includes(element.type)">
			<component :isEditable="isEditable" v-bind:is="'InputComponent'" :element="element"></component>
		</div>
		<div v-else-if="number.includes(element.type)">
			<component :isEditable="isEditable" v-bind:is="'InputComponent'" :element="element"></component>
		</div>
		<div v-else-if="row.includes(element.type)">
			<component :isEditable="isEditable" v-bind:is="'RowComponent'" :element="element"></component>
		</div>
		<div v-else>
			<component :isEditable="isEditable" v-bind:is="'InputComponent'" :element="element"></component>
		</div>
	</div>
</template>
<script>
import InputComponent from "@/modules/builder/Reflect/components/InputComponent"
import RowComponent from "@/modules/builder/Reflect/components/RowComponent"

export default {
	name: "reflect-component",
	components: {
		InputComponent,
		RowComponent,
		Subcomponents: () => import("../components/subcomponents.vue")
	},
	props: {
		element: {
			required: true,
			type: Object
		},
		isEditable: {
			required: true,
			type: Boolean
		}
	},
	data() {
		return {
			/**
			 * DOC
			 * macrocategorie definite sopra, il nome fa riferimento al campo "type" dello store
			 *
			 * */
			input: ["text", "h1", "h2", "h3", "img", "empl", "editor", "seen"],
			number: ["number"],

			row: ["row", "align-center", "align-left", "align-right"]
		}
	}
}
</script>
<style>
.input_cst {
	border: 1px solid #dcdfe6 !important;
	font-family: "Montserrat", sans-serif;
	background-color: transparent;
}
</style>
